<template>
    <span>{{this.reward_name}}</span>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {getRewardName} from '../../../libraries/utils';

    export default {
        name: "IncRewardName",
        props: ['reward', 'type'],
        computed: {
            reward_name: function () {
                return getRewardName(this.reward, this.type, this.locale_currency);
            },
            ...mapGetters('restaurant', {
                locale_currency: 'localeCurrency'
            })
        }
    }
</script>
